var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('LoginPage',{on:{"login":function($event){return _vm.login($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }